import { render, staticRenderFns } from "./IaCard.vue?vue&type=template&id=3a006506&scoped=true"
import script from "./IaCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./IaCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IaCard.vue?vue&type=style&index=0&id=3a006506&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a006506",
  null
  
)

export default component.exports